/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateDoubleMaterialitySurveyDto } from '../models';
// @ts-ignore
import type { DoubleMaterialityActivationStatsDto } from '../models';
// @ts-ignore
import type { DoubleMaterialitySurveyDto } from '../models';
// @ts-ignore
import type { UpdateDoubleMaterialitySurveyDto } from '../models';
/**
 * DoubleMaterialitySurveysApi - axios parameter creator
 * @export
 */
export const DoubleMaterialitySurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDoubleMaterialitySurveyDto} createDoubleMaterialitySurveyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerCreate: async (createDoubleMaterialitySurveyDto: CreateDoubleMaterialitySurveyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDoubleMaterialitySurveyDto' is not null or undefined
            assertParamExists('doubleMaterialitySurveysControllerCreate', 'createDoubleMaterialitySurveyDto', createDoubleMaterialitySurveyDto)
            const localVarPath = `/api/dm/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDoubleMaterialitySurveyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerFindAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dm/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerFindByStakeholderId: async (stakeholderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stakeholderId' is not null or undefined
            assertParamExists('doubleMaterialitySurveysControllerFindByStakeholderId', 'stakeholderId', stakeholderId)
            const localVarPath = `/api/dm/surveys/by-stakeholder/{stakeholderId}`
                .replace(`{${"stakeholderId"}}`, encodeURIComponent(String(stakeholderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerGetActivationStats: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialitySurveysControllerGetActivationStats', 'id', id)
            const localVarPath = `/api/dm/surveys/{id}/activation-stats`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerRemove: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialitySurveysControllerRemove', 'id', id)
            const localVarPath = `/api/dm/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDoubleMaterialitySurveyDto} updateDoubleMaterialitySurveyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerUpdate: async (id: string, updateDoubleMaterialitySurveyDto: UpdateDoubleMaterialitySurveyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialitySurveysControllerUpdate', 'id', id)
            // verify required parameter 'updateDoubleMaterialitySurveyDto' is not null or undefined
            assertParamExists('doubleMaterialitySurveysControllerUpdate', 'updateDoubleMaterialitySurveyDto', updateDoubleMaterialitySurveyDto)
            const localVarPath = `/api/dm/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDoubleMaterialitySurveyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DoubleMaterialitySurveysApi - functional programming interface
 * @export
 */
export const DoubleMaterialitySurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DoubleMaterialitySurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDoubleMaterialitySurveyDto} createDoubleMaterialitySurveyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialitySurveysControllerCreate(createDoubleMaterialitySurveyDto: CreateDoubleMaterialitySurveyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleMaterialitySurveyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialitySurveysControllerCreate(createDoubleMaterialitySurveyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialitySurveysApi.doubleMaterialitySurveysControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialitySurveysControllerFindAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DoubleMaterialitySurveyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialitySurveysControllerFindAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialitySurveysApi.doubleMaterialitySurveysControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialitySurveysControllerFindByStakeholderId(stakeholderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleMaterialitySurveyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialitySurveysControllerFindByStakeholderId(stakeholderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialitySurveysApi.doubleMaterialitySurveysControllerFindByStakeholderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialitySurveysControllerGetActivationStats(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleMaterialityActivationStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialitySurveysControllerGetActivationStats(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialitySurveysApi.doubleMaterialitySurveysControllerGetActivationStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialitySurveysControllerRemove(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialitySurveysControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialitySurveysApi.doubleMaterialitySurveysControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDoubleMaterialitySurveyDto} updateDoubleMaterialitySurveyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialitySurveysControllerUpdate(id: string, updateDoubleMaterialitySurveyDto: UpdateDoubleMaterialitySurveyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleMaterialitySurveyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialitySurveysControllerUpdate(id, updateDoubleMaterialitySurveyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialitySurveysApi.doubleMaterialitySurveysControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DoubleMaterialitySurveysApi - factory interface
 * @export
 */
export const DoubleMaterialitySurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DoubleMaterialitySurveysApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateDoubleMaterialitySurveyDto} createDoubleMaterialitySurveyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerCreate(createDoubleMaterialitySurveyDto: CreateDoubleMaterialitySurveyDto, options?: RawAxiosRequestConfig): AxiosPromise<DoubleMaterialitySurveyDto> {
            return localVarFp.doubleMaterialitySurveysControllerCreate(createDoubleMaterialitySurveyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerFindAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<DoubleMaterialitySurveyDto>> {
            return localVarFp.doubleMaterialitySurveysControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerFindByStakeholderId(stakeholderId: string, options?: RawAxiosRequestConfig): AxiosPromise<DoubleMaterialitySurveyDto> {
            return localVarFp.doubleMaterialitySurveysControllerFindByStakeholderId(stakeholderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerGetActivationStats(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DoubleMaterialityActivationStatsDto> {
            return localVarFp.doubleMaterialitySurveysControllerGetActivationStats(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerRemove(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialitySurveysControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDoubleMaterialitySurveyDto} updateDoubleMaterialitySurveyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialitySurveysControllerUpdate(id: string, updateDoubleMaterialitySurveyDto: UpdateDoubleMaterialitySurveyDto, options?: RawAxiosRequestConfig): AxiosPromise<DoubleMaterialitySurveyDto> {
            return localVarFp.doubleMaterialitySurveysControllerUpdate(id, updateDoubleMaterialitySurveyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DoubleMaterialitySurveysApi - object-oriented interface
 * @export
 * @class DoubleMaterialitySurveysApi
 * @extends {BaseAPI}
 */
export class DoubleMaterialitySurveysApi extends BaseAPI {
    /**
     * 
     * @param {CreateDoubleMaterialitySurveyDto} createDoubleMaterialitySurveyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialitySurveysApi
     */
    public doubleMaterialitySurveysControllerCreate(createDoubleMaterialitySurveyDto: CreateDoubleMaterialitySurveyDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialitySurveysApiFp(this.configuration).doubleMaterialitySurveysControllerCreate(createDoubleMaterialitySurveyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialitySurveysApi
     */
    public doubleMaterialitySurveysControllerFindAll(options?: RawAxiosRequestConfig) {
        return DoubleMaterialitySurveysApiFp(this.configuration).doubleMaterialitySurveysControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stakeholderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialitySurveysApi
     */
    public doubleMaterialitySurveysControllerFindByStakeholderId(stakeholderId: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialitySurveysApiFp(this.configuration).doubleMaterialitySurveysControllerFindByStakeholderId(stakeholderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialitySurveysApi
     */
    public doubleMaterialitySurveysControllerGetActivationStats(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialitySurveysApiFp(this.configuration).doubleMaterialitySurveysControllerGetActivationStats(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialitySurveysApi
     */
    public doubleMaterialitySurveysControllerRemove(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialitySurveysApiFp(this.configuration).doubleMaterialitySurveysControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDoubleMaterialitySurveyDto} updateDoubleMaterialitySurveyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialitySurveysApi
     */
    public doubleMaterialitySurveysControllerUpdate(id: string, updateDoubleMaterialitySurveyDto: UpdateDoubleMaterialitySurveyDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialitySurveysApiFp(this.configuration).doubleMaterialitySurveysControllerUpdate(id, updateDoubleMaterialitySurveyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

